module.exports = __webpack_public_path__ + "img/windSuction--isSpanBySpan.90bf88fb.png";